export default {"src":"/_next/static/media/edible-garden.79adbe72.svg","height":116,"width":116,"blurWidth":0,"blurHeight":0};